import './component';
import './config';
import './preview';

Shopware.Service('cmsService').registerCmsElement({
    name: 'acris-blog-group',
    label: 'acris-blog.elements.blogGroup.label',
    component: 'sw-cms-el-acris-blog-group',
    configComponent: 'sw-cms-el-config-acris-blog-group',
    previewComponent: 'sw-cms-el-preview-acris-blog-group',
    defaultConfig: {
        groups: {
            source: 'static',
            value: []
        },
        blogPostsPerPage: {
            source: 'static',
            value: 24
        },
        paginationHorizontalAlignment: {
            source: 'static',
            value: 'center'
        },
        blogPostsLimit: {
            source: 'static',
            value: ''
        },
        layout: {
            source: 'static',
            value: 'box'
        },
        articleSettings: {
            source: 'static',
            value: {}
        },
        blogColumnsXL: {
            source: 'static',
            value: '4'
        },
        blogColumnsLG: {
            source: 'static',
            value: '4'
        },
        blogColumnsMD: {
            source: 'static',
            value: '3'
        },
        blogColumnsSM: {
            source: 'static',
            value: '2'
        },
        blogColumnsXS: {
            source: 'static',
            value: '1'
        }

    }
});
